import React, { useEffect } from "react";

const NotFound = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "/";
    }, 3000); // Redirect after 3 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <h1 style={{ fontSize: '4rem', color: '#4db749' }}>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you are looking for does not exist or has been moved.</p>
      <p>You will be redirected to the homepage shortly.</p>
      <a href="/" style={{ color: '#4db749', textDecoration: 'underline', marginTop: '1em' }}>Go to Homepage</a>
    </div>
  );
};

export default NotFound; 